export enum ACTIONS {
  SET_WIN_STATUS = 'SET_WIN_STATUS',
}

export interface IWinStatusState {
  winner: string;
  winningAmount: number;
}
